<div
  class="ai-chatbot-message ai-chatbot-message-{{ message.role }}"
  [class.ai-chatbot-message-presentations]="
    message.content?.type === 'presentations' ||
    message.content?.type === 'single_presentation'
  "
>
  <div class="ai-chatbot-message-container">
    <span
      class="ai-chatbot-message-container-text"
      *ngIf="message.role === 'user' || message.role === 'error'"
    >
      {{ message.content?.displayMessage || message.content?.message }}
    </span>
    <span
      class="ai-chatbot-message-container-text"
      *ngIf="message.role === 'assistant'"
      [innerHtml]="message.content?.displayMessage || message.content?.message"
    >
    </span>
    <button
      mat-icon-button
      class="ai-chatbot-message-container-resend"
      aria-label="Resend message"
      type="button"
      *ngIf="message.isNotSuccessful"
      (click)="aiChatbotService.sendMessage(message)"
    >
      <mat-icon
        svgIcon="restart"
        class="ai-chatbot-message-container-resend-icon"
      ></mat-icon>
    </button>
  </div>

  <div
    class="ai-chatbot-message-categories"
    *ngIf="
      message.content?.categories?.style ||
      message.content?.categories?.contents?.length ||
      message.content?.categories?.industry
    "
  >
    <ai-chatbot-category-chip
      label="Style"
      icon="layout"
      *ngIf="message.content.categories?.style"
      [options]="aiChatbotService.styles"
      [selectedValue]="message.content.categories?.style"
      [isDisplayOnly]="true"
    ></ai-chatbot-category-chip>

    <ai-chatbot-category-chip
      label="Content"
      icon="content"
      *ngFor="let content of message.content.categories?.contents"
      [options]="aiChatbotService.contents"
      [selectedValue]="content"
      [isDisplayOnly]="true"
    ></ai-chatbot-category-chip>

    <ai-chatbot-category-chip
      label="Industry"
      icon="industry"
      *ngIf="message.content.categories?.industry"
      [options]="aiChatbotService.industries"
      [selectedValue]="message.content.categories?.industry"
      [isDisplayOnly]="true"
    ></ai-chatbot-category-chip>
  </div>

  <div
    class="ai-chatbot-message-presentations"
    *ngIf="message.content?.type === 'presentations'"
  >
    <div class="ai-chatbot-message-presentations-row">
      <button
        type="button"
        *ngFor="let presentation of getSearchedPresentations(); let i = index"
        title="Use {{ presentation.name }}"
        class="ai-chatbot-message-presentations-row-item"
        [style.animation-delay.s]="i"
        tabindex="0"
        (click)="onExpandPresentation(presentation)"
        (keydown)="onPresentationOptionKeyDown($event, presentation)"
        [disabled]="aiChatbotService.isProcessing"
      >
        <div class="ai-chatbot-message-presentations-row-item-presentation">
          <presentation-preview
            #presentationPreview
            [productCode]="presentation.productCode"
            [attributeData]="presentation.attributeData"
            [disableAutoRefresh]="true"
            [aiContext]="true"
          >
          </presentation-preview>
        </div>
        <span class="ai-chatbot-message-presentations-row-item-name">
          Option {{ i + 1 }}
        </span>
      </button>
    </div>
  </div>

  <div
    class="ai-chatbot-message-single-presentation"
    *ngIf="message.content?.type === 'single_presentation'"
  >
    <div id="preview-holder" class="preview-holder">
      <presentation-preview
        #presentationPreview
        [productCode]="message.content?.data.productCode"
        [attributeData]="message.content?.data.attributeData"
        [disableAutoRefresh]="true"
        [aiContext]="true"
      >
      </presentation-preview>
    </div>
  </div>

  <div
    class="ai-chatbot-message-buttons"
    *ngIf="
      isLastMessage &&
      (message.content?.type === 'presentations' ||
        message.content?.type === 'single_presentation')
    "
  >
    <div class="ai-chatbot-message-buttons-left">
      <mat-chip
        class="ai-chatbot-message-buttons-chip"
        tabindex="0"
        (click)="sendMessage('More Presentations')"
        (keydown)="onChipKeyDown($event, 'More Presentations')"
        *ngIf="message.content?.type === 'presentations'"
      >
        <mat-icon
          svgIcon="ai-chatbot-more-presentations"
          class="ai-chatbot-message-buttons-chip-icon"
        ></mat-icon>
        More Presentations
      </mat-chip>

      <mat-chip
        class="ai-chatbot-message-buttons-chip"
        tabindex="0"
        (click)="sendMessage('Brighter Colors')"
        (keydown)="onChipKeyDown($event, 'Brighter Colors')"
      >
        <mat-icon
          svgIcon="painter-brush"
          class="ai-chatbot-message-buttons-chip-icon"
        ></mat-icon>
        Brighter Colors
      </mat-chip>

      <mat-chip
        class="ai-chatbot-message-buttons-chip"
        tabindex="0"
        (click)="sendMessage('Illustrative Images')"
        (keydown)="onChipKeyDown($event, 'Illustrative Images')"
        [hidden]="true"
      >
        <mat-icon
          svgIcon="image"
          class="ai-chatbot-message-buttons-chip-icon"
        ></mat-icon>
        Illustrative Images
      </mat-chip>
    </div>

    <div
      class="ai-chatbot-message-buttons-right"
      *ngIf="message.content?.type === 'single_presentation'"
    >
      <button
        class="ai-chatbot-message-buttons-open btn btn-primary btn-block"
        type="button"
        aria-label="Open presentation in editor"
        tabindex="0"
        (click)="openPresentationInEditor()"
      >
        Open in Editor
      </button>
    </div>
  </div>
</div>
